
const ACTIVE_STATUS = ["SCHEDULED", "PENDING", "ACCEPTED", "PREPARED", "ASSIGNED", "EN_ROUTE_PICKUP", "ARRIVED_PICKUP", "PICKED", "EN_ROUTE_DROPOFF", "ARRIVED_DROPOFF"];
const INACTIVE_STATUS = ["DELIVERED", "COMPLETED", "CANCELLED"];
const ORDER_STATUS = ["PENDING", "ACCEPTED"];
const DAYS = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];


export { ACTIVE_STATUS, INACTIVE_STATUS, ORDER_STATUS, DAYS };
